import {ENDPOINT, METHOD} from '@/constants';
import {DTO} from '@/shared';
import {IBodyRegisterPartner} from '@/types';

export class CheckTokenActivateDTO extends DTO {
  public static url = ENDPOINT.ACTIVATE;
  public url = ENDPOINT.ACTIVATE;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;

  constructor(public body: {token?: string}) {
    super();
  }
}

export class RegisterPartnerDTO extends DTO {
  public static url = ENDPOINT.REGISTER_PARTNER;
  public url = ENDPOINT.REGISTER_PARTNER;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;
  public headers?: Record<string, string>;

  constructor(
    public body: IBodyRegisterPartner,
    headers?: Record<string, string>,
  ) {
    super();
    this.headers = headers;
  }
}

export class SyncBoDTO extends DTO {
  public url = ENDPOINT.SYNC_BO_TEMPLATES;
  public method = METHOD.GET;
  public body: undefined;
  public param: undefined;
  constructor(public query: {
    override: boolean;
  }) {
    super();
  }
}
